import { TransactionCodeGroupModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

export class TransactionCodeGroup extends DomainEntity<TransactionCodeGroupModelDto> {
    public static from(dto: TransactionCodeGroupModelDto): TransactionCodeGroup {
        return new TransactionCodeGroup(dto);
    }

    public createDefault(): this {
        throw new Error('createDefault not implemented');
    }

    public get id() {
        return this.dto.id;
    }

    public get name() {
        return this.dto.name ?? '';
    }

    public set name(value: string) {
        this.dto.name = value;
    }

    public get isReadOnly() {
        return this.dto.isReadOnly ?? false;
    }
}
